import { Component } from '@angular/core';
import { OnInit,  Output, EventEmitter,ViewChild,ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggingService } from 'src/app/services/logging.service';
import { AuthService } from 'src/app/services/auth.service';
import { Input } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';
import { HourglassService } from 'src/app/services/hourglass.service';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(duration);

@Component({
  selector: 'app-form-entry',
  templateUrl: './form-entry.component.html',
  styleUrls: ['../hourglass.component.css']
})

export class FormEntryComponent implements OnInit {
  @ViewChild('dt_task') dt_task!: ElementRef<HTMLInputElement>;
  @Output() taskWindowLazyLoad = new EventEmitter<string>();
  @Output() parentRefresh = new EventEmitter<string>();
  @Output() parentGridReset = new EventEmitter<string>();
  token!: string;
  ddSettingsTask: IDropdownSettings = {};
  entryForm: any = {
    id: "",
    employeeID: "",
    taskID: "",
    taskObject: [],
    entryDt: dayjs(Date.now()).format('YYYY-MM-DD'),
    entryStart: "",
    entryEnd: "",
    entryNotes: "",
    entryBillable: 0,
    entryDurationHrs: 0,
    entryDurationMins: 30,
    entryDurationLabel: "-",
    entryTimeZone: "EST",
    entryAssignees: [],
    entryAssigneeNames: [],
    entryFormat: "startduration",
    entryMinDt: "",
    entryMaxDt: "",
    entryTypeID: "",
    isReadOnly: false

  };
  flagAllAssigned = false;
  listTags: any[] = [];
  listEmployees: any[] = [];
  listAssignees: any[] = [];
  listAssigneeNames: any[] = [];
  listTasks: any[] = [];
  listTimeWeeks: any[] = [];
  listWeekDays: any[] = [{ "dayLabel": "Sat May 24" }];
  listTimeTypes: any[] = [];
  errorMessage = "";
  saveMode = "add";
  searchText = "";
  showModal = "none";
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  impersonatedUser: any = this.userID;
  timeEntrySettings: any;
  showDupeRow = false;
  selectedWeekStart: dayjs.Dayjs | null = null;
  selectedWeekEnd: dayjs.Dayjs | null = null;



  @Input() showAddTaskButton = true;

  constructor(
    public authService: AuthService,
    private hourglassService: HourglassService,
    private route: ActivatedRoute,
    private loggingService: LoggingService
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    this.ddSettingsTask = {
      singleSelection: true,
      idField: 'id',
      textField: 't_name',
      enableCheckAll: false,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    setTimeout(() => {
      this.timeEntrySettings = sessionStorage.getItem('wOSUserPrefs');
    })
  }

  showCalendar(): void {
    this.dt_task.nativeElement.showPicker();
  }

  loadFromEntryTab(data:any): void {
    this.listEmployees = data.employees;
    this.listTasks = data.tasks;
    this.listTimeWeeks = data.timeweeks;
    this.listTimeTypes = data.tasktypes;
    this.entryForm.employeeID = this.userID;
  }

  onTaskSelect(item: any) {
    console.log("onTaskSelect", this.entryForm.taskObject)
    this.entryForm.taskID = item.id;
    this.getTaskAssignees();
  }

  getUXData(user: string, mode: string, skipDateValidation = false, preserveWeek = false): void {
    this.hourglassService.getTimeEntryUxData(user, mode, null, this.token).then((data) => {
      this.listEmployees = data.employees;
      this.listTasks = data.tasks;
      this.listTimeWeeks = data.timeweeks;
      this.listTimeTypes = data.tasktypes;
      this.entryForm.employeeID = user;

      console.log("Preserve Week, date validation", preserveWeek, skipDateValidation)
      // Only set week if NOT preserving
      if (!preserveWeek) {
        const dtwkstart = dayjs(this.listTimeWeeks[0].wkstart);
        const dtwkend = dayjs(this.listTimeWeeks[0].wkend);

        this.selectedWeekStart = dtwkstart;
        this.selectedWeekEnd = dtwkend;

        this.entryForm.entryMinDt = dtwkstart.format('YYYY-MM-DD');
        this.entryForm.entryMaxDt = dtwkend.format('YYYY-MM-DD');
      } else {
        const selectedweek = $('#sel_timeweek').val();
        const week = this.listTimeWeeks.find((x) => x.id == selectedweek);
        this.entryForm.entryMinDt = dayjs(week.wkstart).format('YYYY-MM-DD')
        this.entryForm.entryMaxDt = dayjs(week.wkend).format('YYYY-MM-DD')
      }

      if (!skipDateValidation) {
        const currentDate = dayjs(this.entryForm.entryDt);
        if (
          !currentDate.isValid() ||
          currentDate.isBefore(this.selectedWeekStart!) ||
          currentDate.isAfter(this.selectedWeekEnd!)
        ) {
          this.entryForm.entryDt = this.selectedWeekStart!.format("YYYY-MM-DD");
        }
      }
    });
  }

  setEntryType(data: any): void {
    const a: any = data.split(':');
    const srch = (a !== undefined) ? a[0] : '';
    let found = -1;
    for (let x = 0; x < this.listTimeTypes.length; x++) {
      const o = this.listTimeTypes[x];
      //console.log("setEntryType",o)
      if (o.log_type == srch.trim()) {
        found = o.id;
        break;
      }
    }
    console.log("found", found)
    setTimeout(() => {
      this.entryForm.entryTypeID = (found == -1) ? 4 : found; //task if not found
    })
  }

  // called when a time entry is clicked from the Time Entry tab grid
  loadFromGrid(dataset: any, mode:any = "edit"): void {
    console.log("loadFromGrid",dataset)


    this.entryForm.isReadOnly = (dataset.entry_owner != this.userID) ? true : false;
    this.saveMode = (dataset.id == '') ? "add" : (this.entryForm.isReadOnly) ? "admin lock" : "edit";
    this.entryForm.id = dataset.id;
    this.entryForm.entryTypeID = dataset.entry_type;
    this.entryForm.taskID = dataset.task_id;
    this.entryForm.entryDt = dayjs(dataset.t_date).format('YYYY-MM-DD');
    // set start time
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const start = dayjs.utc(dataset.t_start);
    const template = start.tz(zone).format('HH:mm');
    this.entryForm.entryStart = template;
    this.entryForm.entryNotes = dataset.notes;
    this.entryForm.entryBillable = dataset.billable;
    this.entryForm.entryAssignees = dataset.assignees;
    this.entryForm.entryAssigneeNames = dataset.assignee_names;
    // do duration math
    const data = dataset.duration;
    const mins = (data % 60);
    const hrs = (data - mins) / 60;
    // populate variables
    this.entryForm.entryDurationHrs = hrs;
    this.entryForm.entryDurationMins = mins;
    this.setTaskFilter();

    setTimeout(() => {
      this.getTaskAssignees(dataset.assignees);
      if(mode == 'copy') this.showCalendar()
    },500)
  }

  toggleAllAssigned(): void {
    this.flagAllAssigned = !this.flagAllAssigned;
    $('.cbassignee').prop('checked',this.flagAllAssigned)
  }

  loadFromCalendar(dataset: any): void {
    console.log("fromCalendar", dataset)
    this.saveMode = "add";
    this.entryForm.taskID = dataset.returnID;
    this.entryForm.entryDt = dayjs(dataset.start.dateTime).format('YYYY-MM-DD');

    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const start = dayjs.utc(dataset.start.dateTime);
    const end = dayjs.utc(dataset.end.dateTime);
    let template = start.tz(zone).format('HH:mm');

    this.entryForm.entryStart = template;
    template = end.tz(zone).format('HH:mm');
    this.entryForm.entryEnd = template;

    if (this.entryForm.taskID > 0) {
      this.getTaskAssignees();
      $('#ta_notes').trigger('focus');
    } else {
      try {
        $('#entryModal .modal-title').html("<i class='fas fa-fw fa-lg fa-check me-1'></i>Add Task");
        this.toggleModal('show');
      } catch (ex) {
        console.log("Error Loading Modal from calendar", ex)
      }
    }
  }

  resetEntry(preserveDate = false): void {
    this.entryForm.id = 0;
    this.entryForm.entryTypeID = ""
    this.entryForm.taskID = "";
    this.entryForm.taskObject = [];
    this.entryForm.entryDt = dayjs(Date.now()).format('YYYY-MM-DD');
    this.entryForm.entryStart = "";
    this.entryForm.entryEnd = "";
    this.entryForm.entryNotes = "";
    this.entryForm.entryDurationHrs = 0;
    this.entryForm.entryDurationMins = 30;
    this.entryForm.entryBillable = 0;
    this.saveMode = "add";
    this.entryForm.isReadOnly = false;
    this.flagAllAssigned = false;
    $('#sel_task').trigger('focus');
    this.parentGridReset.emit()
  }

  refreshFromTaskAdd(key: any): void {
    console.log('form-entry refreshFromTaskAdd',key)
    this.entryForm.taskID = key;
    setTimeout(() => {
      this.setTaskFilter();
    },500)
  }

  calculateDuration(): void {
    if (this.entryForm.entryStart != '' && this.entryForm.entryEnd != '') {
      const start = dayjs(new Date(this.entryForm.entryDt + ' ' + this.entryForm.entryStart));
      const end = dayjs(new Date(this.entryForm.entryDt + ' ' + this.entryForm.entryEnd));
      const duration: number | 0 = end.diff(start, "minutes");
      const duration_h = (duration / 60);
      this.entryForm.entryDuration = duration;
      this.entryForm.entryDurationLabel = (duration < 60) ? duration + ' minutes' : duration_h.toFixed(2) + ' hours';
    } else {
      this.entryForm.entryDurationLabel = "-";
    }
  }

  getEmployeeTasks(): void {
    console.log("getEmployeeTasks")
    this.hourglassService.getTimeEntryUxData(this.entryForm.employeeID, "tasks", null, this.token).then(r => {
      this.listTasks = r.tasks;
    });
    this.parentRefresh.emit(this.entryForm.employeeID);
  }

  getTaskAssignees(params: any = null): void {
    const task = this.listTasks.find(obj => obj.id == this.entryForm.taskID);
    if (!task) {
      console.warn(`Task not found for taskID=${this.entryForm.taskID}`);
      
      this.entryForm.entryAssignees = task.assignees.replace(/ /g, '').split(',');
      setTimeout(() => {
        $('.cbassignee').prop('checked', false);
        this.entryForm.entryAssigneeNames = task.assignee_names.split(',');
        if (params != null) {
          const p = params.split(',');
          p.forEach((x: string) => {
            const obj = $('#cbassignee_' + x.trim());
            obj.prop('checked', true);
          });
        } else {
          const obj = $('#cbassignee_' + this.userID);
          obj.prop('checked', true);
        }
      });
    }
    this.entryForm.entryAssignees = task.assignees?.replace(/ /g, '').split(',') || [];
    setTimeout(() => {
      $('.cbassignee').prop('checked', false);
      this.entryForm.entryAssigneeNames = task.assignee_names?.split(',') || [];
      console.log("getTaskAssignees parameters", params);
      if (params != null) {
        const p = params.split(',');
        p.forEach((x: string) => {
          const obj = $('#cbassignee_' + x.trim());
          obj.prop('checked', true);
        });
      } else {
        const obj = $('#cbassignee_' + this.userID);
        obj.prop('checked', true);
        console.log("no assignees to check - check logged in user");
      }
    });
  }

  addTask() {
    $('#entryModal .modal-title').html("<i class='fas fa-fw fa-lg fa-check me-1'></i>Add Task");
    setTimeout(() => {
      this.toggleModal('show');
    })
  }

  checkTaskAssignee(id: string): boolean {
    const assignees = this.entryForm.entryAssignees;
    return assignees.includes(id);
  }

  // sets task filter 
  setTaskFilter() {
    const obj = [this.listTasks.find(o => o.id == this.entryForm.taskID)];
    this.entryForm.taskObject = obj;
    console.log("setTaskFilter",obj)
    this.getTaskAssignees();
  }

  toggleModal(mode: string) {
    this.showModal = (mode == 'show') ? "show" : "hide";
    ($('#entryModal') as any).modal(this.showModal);
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  saveEntry(): void {
    if (this.entryForm.entryTypeID == '') {
      this.errorMessage = 'Entry type is required.';
      this.clearErrorMessage();
      $('#sel_entrytype').trigger('focus');
      return;
    }

    if (this.entryForm.employeeID == '') {
      this.errorMessage = 'Employee is required.';
      this.clearErrorMessage();
      $('#sel_employee').trigger('focus');
      return;
    }

    if (this.entryForm.taskID == '') {
      this.errorMessage = 'Task is required.';
      this.clearErrorMessage();
      $('#sel_task').trigger('focus');
      return;
    }

    let assigneeFlag = false;
    for (let x = 0; x < this.entryForm.entryAssignees.length; x++) {
      const obj = $('#cbassignee_' + this.entryForm.entryAssignees[x].trim());
      if (obj.is(':checked')) {
        assigneeFlag = true;
        break;
      }
    }

    if (!assigneeFlag) {
      this.errorMessage = 'Select at least one assignee from the Enter For section to continue.';
      this.clearErrorMessage();
      return;
    }

    if (this.entryForm.entryDt == '' || this.entryForm.entryDt == 'Invalid Date') {
      this.errorMessage = 'Entry date is required.';
      this.clearErrorMessage();
      $('#dt_task').trigger('focus');
      return;
    }

    if (this.entryForm.entryStart == '') {
      this.errorMessage = 'Start time is required.';
      this.clearErrorMessage();
      $('#start_entry').trigger('focus');
      return;
    }

    if (this.entryForm.entryDuration == '' || this.entryForm.entryDuration < 1) {
      this.errorMessage = 'Duration must be at least 1 minute.';
      this.clearErrorMessage();
      $('#end_entry_duration').trigger('focus');
      return;
    }

    if (this.entryForm.entryNotes == '') {
      this.errorMessage = 'Time Entry notes are required.';
      this.clearErrorMessage();
      $('#ta_notes').trigger('focus');
      return;
    }

    const entryDate = this.entryForm.entryDt;
    const startDateTime = `${entryDate} ${this.entryForm.entryStart}`;
    const endDateTime = `${entryDate} ${this.entryForm.entryEnd}`;

    this.entryForm.entryStart = dayjs(startDateTime, "YYYY-MM-DD HH:mm").utc().format();
    this.entryForm.entryEnd = dayjs(endDateTime, "YYYY-MM-DD HH:mm").utc().format();

    this.entryForm.entity = "entry";
    this.entryForm.mode = this.saveMode;
    this.entryForm.enteredBy = this.userID;

    const selected = [];
    for (let x = 0; x < this.entryForm.entryAssignees.length; x++) {
      const obj = $('#cbassignee_' + this.entryForm.entryAssignees[x].trim());
      if (obj.is(':checked')) selected.push(this.entryForm.entryAssignees[x].trim());
    }

    this.entryForm.entryAssignees = selected.join(',');
    this.entryForm.entryBillable = (this.entryForm.entryBillable == false) ? 0 : 1;

    this.hourglassService.saveTimeEntryEntity(this.entryForm, this.token).then(r => {
      try {
        const newDate = this.entryForm.entryDt;
        const newStart = this.entryForm.entryEnd;
        this.resetEntry(true);
        this.entryForm.entryDt = newDate;
        this.entryForm.entryStart = newStart;
        this.entryForm.entryDurationHrs = 0;
        this.entryForm.entryDurationMins = 30;
        this.getUXData(this.userID, "all",true,true);

        this.parentRefresh.emit(this.entryForm.employeeID);
      } catch (ex: any) {
        this.errorMessage = "Error saving time entry. Please try again - " + ex.message;
        alert("Error trap entry save" + ex.message);
      }
    });
  }

  onDateChanged(): void {
    const selectedDate = dayjs(this.entryForm.entryDt); // Already in YYYY-MM-DD format

    // Set min to Monday and max to Sunday
    const startOfWeek = selectedDate.startOf('week').add(1, 'day'); // Monday
    const endOfWeek = selectedDate.endOf('week').add(1, 'day');     // Sunday

    this.entryForm.entryMinDt = startOfWeek.format('YYYY-MM-DD');
    this.entryForm.entryMaxDt = endOfWeek.format('YYYY-MM-DD');
  }


  clearErrorMessage(delay: any = 3500): void {
    setTimeout(() => {
      this.errorMessage = '';
    }, delay)
  }
}
